export default "__VITE_ASSET__BVlmN4co__"